import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { useSessionValidation } from '../../../utils/sessionValidation';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import CopyrightIcon from '@mui/icons-material/Copyright';

const UserEdit = () => {
    // Session validation
    useSessionValidation();
    
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    // const companyId = 2;
    // const userId = 1;
    // const isAuthenticated = true;
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId]);

    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        UserName: '',
        Email: '',
        ContactNumber: '',
        isSubmit: false
    });

    useEffect(() => {
        fetchData('UserApi', `/UserDetails/${id}`, token)//, token
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching User Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));

        // Update UserName based on the combination of FirstName and LastName
        if (name === 'FirstName' || name === 'LastName') {
            const updatedUserName = `${formData.FirstName.toLowerCase()}_${formData.LastName.toLowerCase()}`;
            const limitedUserName = updatedUserName.slice(0, 15);
            setFormData((prevFormData) => ({
                ...prevFormData,
                UserName: limitedUserName,
            }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        // Validate form data here if needed

        updateData('UserApi', `${id}`, formData, token)//, token
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/UserIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>User - Edit</h6>
                    <Button
                        variant="contained"
                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                        onClick={handleSubmit}
                    >
                        Update
                    </Button>

                    <Button
                        variant="contained"
                        component={Link}
                        to="/UserIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                    >
                        Cancel
                    </Button>
                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                            First Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.FirstName}
                            name='FirstName'
                            onChange={handleChange}
                            type="text" placeholder="Enter First Name"
                            maxLength={30}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                            Last Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.LastName}
                            name='LastName'
                            onChange={handleChange}
                            type="text" placeholder="Enter Last Name"
                            maxLength={30}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                            User Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.UserName}
                            name='UserName'
                            onChange={handleChange}
                            type="text" placeholder="Enter User Name"
                            readOnly
                        />
                    </div>
                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                            Contact Number
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.ContactNumber}
                            name='ContactNumber'
                            onChange={handleChange}
                            type="text" placeholder="Enter Contact Number"
                            maxLength={15}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                            Email
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.Email}
                            name='Email'
                            onChange={handleChange}
                            type="text" placeholder="Enter Email"
                            maxLength={40}
                        />
                    </div>

                </div>
            </form>
        </div>
    );
};

export default UserEdit;
